import * as actionTypes from '../actionTypes';

const state = {
  isLoadingPostFileUpload: false,
  postFileUploadMessage: '',
  postFileUploadFailed: '',
};

const initializeStates = JSON.parse(JSON.stringify(state));

function fileReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initializeStates,
      };
    case actionTypes.POST_FILE_UPLOAD_PENDING:
      return {
        ...globalState,
        isLoadingPostFileUpload: true,
      };
    case actionTypes.POST_FILE_UPLOAD_FULFILLED:
      return {
        ...globalState,
        isLoadingPostFileUpload: false,
        postFileUploadMessage: action.data,
        postFileUploadFailed: '',
      };
    case actionTypes.POST_FILE_UPLOAD_FAILURE:
      return {
        ...globalState,
        isLoadingPostFileUpload: false,
        postFileUploadMessage: '',
        postFileUploadFailed: action.error,
      };
    default:
      return globalState;
  }
}

export { fileReducer as default };
